// extracted by mini-css-extract-plugin
export var root = "style-module--root--rP31G";
export var select = "style-module--select--qE7gU";
export var short = "style-module--short--7Vi4d";